import { render, staticRenderFns } from "./UMLVOMoney.vue?vue&type=template&id=05bfe381&scoped=true&"
import script from "./UMLVOMoney.vue?vue&type=script&lang=js&"
export * from "./UMLVOMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bfe381",
  null
  
)

export default component.exports